module.exports = __webpack_public_path__ + "static/media/005.5c1da541.svg";